<mat-card appearance="outlined">
  <mat-card-title>
    <span class="title">{{ 'nssi.standalonePageTitle' | translate }}</span>
  </mat-card-title>
  <mat-card-subtitle>
  </mat-card-subtitle>
  <mat-card-content>
    <div flex layout="row">
      <form flex layout="row">
        <div layout="row" class="title" flex="50" layout-align="start center" layout-wrap>
          <mat-form-field flex="40"
            class="right-padding-16">
            <input
              matInput
              type="text"
              [formControl]="civilId"
              placeholder="{{ 'global.civilId' | translate }}"
              />
              @if (civilId.hasError('onlyNumbers') || civilId.hasError('minlength') || civilId.hasError('maxlength') || civilId.hasError('incorrectEgnFormat')) {
                <mat-error
                  [translate]="'clients.invalidCivilId'">Invalid civil id
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="right-padding-16" flex="40">
              <input
                matInput
                type="text"
                [formControl]="idCardNumber"
                placeholder="{{ 'global.number' | translate }}"
                />
                <mat-label>{{ 'global.number' | translate }}</mat-label>
                @if (idCardNumber.errors) {
                  <mat-error [translate]="'forms.invalidFormat'">Invalid
                    format
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div flex="50" layout="row" class="title" layout-align="end center" layout-wrap>
              <button mat-raised-button class="right-margin-16"
                [disabled]="(!idCardNumber.value || !idCardNumber.valid) || (!civilId.value || !civilId.valid) || (['MI_READ'] | isUnauthorized | async)"
                (click)="getLatestReport()">
                Налична справка
              </button>
              <div class="white-space-no-wrap">
                <button
                  mat-raised-button
                  [disabled]="(!idCardNumber.value || !idCardNumber.valid) || (!civilId.value || !civilId.valid) || (['MI_ADD'] | isUnauthorized | async)"
                  (click)="getNewMi()"
                  >
                  {{ 'mi.getNewMiReport' | translate }}
                </button>
              </div>
            </div>
          </form>

        </div>
        @if (!reportData && !clientReportData && !isReport) {
          <div
            flex
            layout="row"
            layout-align="start center"
            class="left-padding-16"
            >
            <h3 class="edit-screen-card-title">{{ 'mi.noMiFiles' | translate }}</h3>
          </div>
        }
        <!-- <div
        *ngIf="reportData?.data && clientReportData && isReport && !isIdsMatching"
        flex
        layout="row"
        layout-align="start center"
        class="left-padding-16"
        >
        <h3 class="edit-screen-card-title">{{ 'mi.idCardNumberDoNotMatch' | translate }}</h3>
      </div> -->
      @if (reportData?.status === 'success' && !reportData?.data) {
        <div flex layout="row" layout-align="start center" class="left-padding-16">
          <h3 class="edit-screen-card-title">{{ 'mi.missingMiDataLatestReport' | translate }}</h3>
        </div>
      }
      @if (reportData?.status === 'success' && reportData?.data && !isIdCardMatching) {
        <div layout="row" layout-align="start center" class="left-padding-16">
          <h3 class="edit-screen-card-title">{{ 'mi.idCardNumberDoNotMatch' | translate }}</h3>
        </div>
      }
      @if (reportData?.status != 'success') {
        <div flex layout="row" layout-align="start center" class="left-padding-16">
          @if (reportData?.status == 'incorrect_input') {
            <h3 class="edit-screen-card-title">{{ 'mi.incorrectDataMsg' | translate }}</h3>
          }
          @if (reportData?.status == 'not_found') {
            <h3 class="edit-screen-card-title">{{ 'mi.noMiData' | translate }}</h3>
          }
          @if (reportData?.status == 'server_timeout') {
            <h3 class="edit-screen-card-title">{{ 'reports.serverTimeoutError' | translate: {requestTime: requestTime | itfgDateFormat} }}</h3>
          }
          @if (reportData?.status == 'server_error') {
            <h3 class="edit-screen-card-title">{{ 'reports.serverGenericError' | translate: {requestTime: requestTime | itfgDateFormat} }}</h3>
          }
        </div>
      }

      @if (isReport && reportData?.data && isIdCardMatching) {
        <div>
          <itfg-mi-card [isReport]="isReport"
            [isClientDataMatch]="isIdCardMatching"
            [civilId]="civilId.value"
            [idCardNumber]="idCardNumber.value"
            [reportData]="reportData"
            [clientReportData]="clientReportData"
          >
          </itfg-mi-card>
          <div flex layout="row" layout-align="end end" class="margin-right-16px" *ngxPermissionsOnly="'USER_ID_DATA_READ'">
            <span> {{ 'global.operator' | translate }}:&nbsp;</span
              ><span>{{ reportData?.requesterName }}</span>
            </div>
          </div>
        }


